export class IRestParameter {
    serviceName: string;
    functionName: string;
    data?: any;
}